<template>
  <span>
    <button v-if="available" type="button" class="btn btn-outline-primary btn-sm" @click="modalVisible = true">
      <i class="far fa-envelope mr-1"></i> Enviar correo
    </button>
    <contract-email-modal
      :visible="modalVisible"
      :request-id="requestData && requestData.id"
      :contract-type="contractType"
      :source-type="sourceType"
      :provider-email="providerEmail"
      :expires-at="requestData && requestData.expires_at_formatted || ''"
      @close="modalVisible = false"
      @sent="onSent"
    />
  </span>
</template>

<script>
import ContractEmailModal from './ContractEmailModal.vue';

export default {
  name: 'ContractEmailButton',
  components: { ContractEmailModal },
  props: {
    contract: { type: Object, default: null },
    providerEmail: { type: String, default: '' },
    sourceType: { type: Number, required: true },
    contractType: { type: Number, required: true }
  },
  data() { return { modalVisible: false }; },
  computed: {
    requestData() { return this.contract && this.contract.latest_request || null; },
    available() {
      const req = this.requestData;
      return !!(this.contract && req && req.id && [1, 2].includes(Number(req.status)) &&
        req.is_expired !== true && Number(this.contract.status) === 1);
    }
  },
  methods: {
    async onSent(payload) {
      this.modalVisible = false;
      const failed = payload.failed || [];
      // const accepted = payload.accepted || [];
      if (this.$swal) {
        await this.$swal.fire({
          icon: failed.length ? 'warning' : 'success',
          title: failed.length ? 'Envío parcial' : 'Correos procesados',
          // text: `Aceptados por el servidor de correo: ${accepted.length}. Fallidos: ${failed.length}.`,
          confirmButtonText: 'Aceptar'
        });
      }
      this.$emit('sent', payload);
    }
  }
};
</script>
